import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import styles from "./style.module.scss";
import ExpenseNoteMessageForm from "@components/forms/ExpenseNoteMessageForm";

const ValidateExpenseENote = () => {

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title="Validar Nota de Credito/Debito de Gasto"
      backUrl="/user/expenses"
    >
      <ExpenseNoteMessageForm
        formId="providerValidateForm"
        saveRedirectUrl="/user/expenses"
      ></ExpenseNoteMessageForm>

    </PageContainer >
  );
}

export default ValidateExpenseENote;
